export default __webpack_public_path__ + "static/media/speaker-3.9dc11072.png";